import React, { useEffect, useState } from "react";
import { Skeleton } from "antd";

const Preloader = () => {
  const [active, setActive] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setActive(false);
    }, 1200);

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, []);

  return (
    <>
      {active ? (
        <div className="preloader">
          <Skeleton active style={{width:"50%"}}  />
        </div>
      ) : (
         <></>
      )}
    </>
  );
};

export default Preloader;
